
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.9412 6.62502C17.6941 7.50002 20.4118 10.75 20.4118 14.5V15.75M10.0588 15.75V5.75C10.0588 5 10.5764 4.5 11.3529 4.5H12.647C13.4235 4.5 13.9412 5 13.9412 5.75V15.75M10.0588 6.62502C6.30589 7.50002 3.58824 10.75 3.58824 14.5V15.75M23 18.25C23 19 22.4824 19.5 21.7059 19.5H2.29412C1.51765 19.5 1 19 1 18.25V17C1 16.25 1.51765 15.75 2.29412 15.75H21.7059C22.4824 15.75 23 16.25 23 17V18.25Z","stroke":"currentColor","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    